module.exports = __webpack_public_path__ + "img/ins_hover.89c1be91.svg";